class TabGroupState extends WidgetState {
    constructor() {
        super();
    }

    selectTab(selectedTabName: string) {
        for(var tabName in this.childrenStates) {
            (this.childrenStates[tabName] as TabState).selected = false;
        }

        (this.childrenStates[selectedTabName] as TabState).selected = true;
    }

    /**
     * check if two instances of widgetState are equal
     * @param otherWidgetState
     */
    equals(otherWidgetState) {
        if(!super.equals(otherWidgetState)) return false;

        return true;
    }

    /**
     * Create a copy of this state
     */
    getCopy() {
        var result = new TabGroupState();

        result.enabled = this.enabled;
        result.copyChildrenStates(this);

        return result;
    }
}